import { Store } from "@reduxjs/toolkit";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { isoWebPageURL } from "../../models/nominals";
import { loadCurrentUser } from "../../store/common/thunks/user";
import { IRootState } from "../../store/reducers.interfaces";

type IRootCommonState = Pick<IRootState, "common">;

export const initCSRToolbar = async <T extends Store<IRootCommonState>>({
    rehydratingStore,
    store,
}: {
    rehydratingStore: Promise<T>;
    store: T;
}): Promise<void> => {
    // Wait for Redux store to finish loading
    await rehydratingStore;

    // Load the current user. If they're not a CSR, abort without doing anything more.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const user = await store.dispatch(loadCurrentUser() as any).unwrap();
    if (!user || !user.is_csr) {
        return;
    }

    // Load the toolbar component
    const { Toolbar } = await import("./Toolbar");

    // Create container elements
    const document = getDocument();
    if (!document) return;

    const csrToolbarContainer = document.createElement("div");
    csrToolbarContainer.id = "oscarcsr-toolbar-reset";
    document.body.prepend(csrToolbarContainer);

    const csrToolbar = document.createElement("div");
    csrToolbar.id = "oscarcsr-toolbar";
    csrToolbarContainer.appendChild(csrToolbar);

    // Render the toolbar
    createRoot(csrToolbar).render(
        <Provider store={store}>
            <Toolbar
                dashboard={isoWebPageURL.wrap("/store/dashboard/")}
                basket={isoWebPageURL.wrap("/store/basket/")}
            />
        </Provider>,
    );
};
